import { render } from 'preact'
import { App } from './app'

render(<App />, document.getElementById('app') as HTMLElement)

if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js')
}

// Loaded apart: the SDK would grow the main bundle, and is not needed for the first render
if (process.env.NODE_ENV === 'production' && process.env.SENTRY_DSN) {
  const dsn = process.env.SENTRY_DSN
  import('./sentry').then((m) => m.startSentry(dsn))
}
